// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-role=provided-service-form] .label-header{margin-top:5px}[data-role=provided-service-form] textarea{resize:vertical !important}", ""]);
// Exports
module.exports = exports;
